import * as React from 'react';

import { Button, ConsoleDialog } from '@rematter/ui-web';
import { Unlink } from 'lucide-react';

interface OrphanedBookingSalesOrderLink {
  bookingId: string;
  documentNumber: string;
  salesOrderId: string;
  salesOrderNumber: string;
}

interface RemoveOrphanedLinkDialogProps {
  orphanedLink: OrphanedBookingSalesOrderLink;
  open: boolean;
  onRemove: () => void | Promise<void>;
  onCancel: () => void;
}

export const RemoveOrphanedLinkDialog: React.FC<
  RemoveOrphanedLinkDialogProps
> = ({ orphanedLink, open, onRemove, onCancel }) => {
  const [isRemoving, setIsRemoving] = React.useState(false);

  const handleConfirm = async () => {
    setIsRemoving(true);
    try {
      await onRemove();
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <ConsoleDialog
      isOpen={open}
      onOpenChange={(isOpen: boolean) => !isOpen && onCancel()}
      title="Remove Orphaned Link?"
      content={
        <div className="space-y-4">
          <p className="text-sm text-neutral">
            The link between{' '}
            <strong>Booking {orphanedLink.documentNumber}</strong> and{' '}
            <strong>Sales Order {orphanedLink.salesOrderNumber}</strong> is no
            longer used by any loads.
          </p>
          <p className="text-sm text-neutral">
            Would you like to remove this relationship?
          </p>
          <div className="flex justify-end gap-2 pt-4">
            <Button
              variant="outline"
              onPress={onCancel}
              isDisabled={isRemoving}
            >
              Keep Link
            </Button>
            <Button onPress={handleConfirm} isDisabled={isRemoving}>
              <Unlink className="mr-2 h-4 w-4" />
              {isRemoving ? 'Removing...' : 'Remove Link'}
            </Button>
          </div>
        </div>
      }
      className="@RemoveOrphanedLinkDialog"
    />
  );
};
